import React, { useEffect, useMemo, useRef, useState } from "react";
import Button from "../../../components/common/ui/Button";
import {
  CheckBoxInput,
  FileInput,
  RadioInput,
  TextAreaInput,
} from "../../../components/common/ui/Inputs";
import { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../components/common/table/Table";
import { history } from "../../../_helpers";
import { Link, useLocation } from "react-router-dom";
import {
  masterActions,
  staffRequestAction,
  authActions,
  facilityAction,
} from "../../../_store";
import { Popup } from "../../../components/common/ui/NotificationModal/Popup";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import CustomLoader from "../../../components/common/ui/Loader";
import { staffRequestSchema } from "../../../validation/staffRequestSchema";
import { StoredProcedures, UserRoleType } from "../../../_helpers/enumerator";
import ExcelExport from "../../../components/common/ui/Export/ExcelExport";
import generateXlsx from "../../../components/common/export/generateXlsx";
import {
  formatDateTimeAMPM,
  getCurrentDate,
  getCurrentTime,
} from "../../../utils/formatTime";
import PdfViewer from "../../../components/common/PdfViewer/PdfViewer";
import MessageToInmateFormHeader from "./MessageToInmateFormHeader";
import PrivateConvoRequestFormHeader from "./PrivateConvoRequestFormHeader";
//import useTranslate from "../../../utils/useTranslation";
import translateText from "../../../_helpers/GoogleTranslator";
import { getStoredValue } from "../../../_helpers/storagehelper";
function PrivateConversationRequestForm() {
  const componentRef = useRef();
  const componentRef1 = useRef();
  const componentRef2 = useRef();
  const dispatch = useDispatch();
  const location = useLocation();

  const staffRequestID = parseInt(process.env.REACT_APP_STAFF_REQUEST_ACCESSIBLE_FA, 10);
  const STAFF_REQUEST_ACCESSIBLE_FA = [staffRequestID];
  const MAX_FILE_SIZE = parseInt(process.env.REACT_APP_MAX_FILESIZE, 10);
  const formID = location?.state ? location?.state?.formID : 0;
  const formDetails = location?.state ? location?.state?.formDetails : {};
  const sourceFrom = location?.state ? location?.state?.sourceFrom : "";

  const RequestFormType = location?.state
    ? location?.state?.RequestFormType
    : 0;

  const InmateID = location?.state ? location?.state?.InmateID : 0;

  const InmateResidentId = location?.state
    ? location?.state?.InmateResidentId
    : 0;

  const oldRequestFormTitle = location?.state
    ? location?.state?.oldRequestFormTitle
    : 0;

  const loggedUser = getStoredValue("user")?.ManagementUserID;

  const UserRoleID = getStoredValue("user")?.UserRoleID;

  const {
    requestFormInfoResponse,
    formTypeListDropDown,
    loadInmateRequestFormList,
    updateRequestFormTypePopupdata,
    updateChangeRequestFormTypeData,
    submitRequestFormInfoResponse,

    // staffRequestList,
    requestReview,
    LoadFacilityAdminMURequestFormAccessResponse,
    legalRequestFormAccess: PRFormAccess,
    indexValue,
    loading,
  } = useSelector((x) => x?.staffRequest);

  // const { translatedMessages, translateMessages } = useTranslate();

  // const { facilityDetails } = useSelector((x) => x?.facility);
  const { GetFacilityStaffReqInfoResponse, loading: facilityLoader } =
    useSelector((x) => x?.facility);
  const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode);
  const { ReplyMode } = useSelector((x) => x.dropdownOptions);
  const { user, commonFacilityCode } = useSelector((x) => x.auth);

  const [facilityName, setFacilityName] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const [formType, setFormType] = useState(1);
  const [isShowReplayModeModal, setIsShowReplayModeModal] = useState(false);
  const [requestFormTypePopup, setRequestFormTypePopUp] = useState({
    requestFormTypeID: RequestFormType,
    newRequestFormTypeId: 0,
    inmateResidentId: InmateResidentId,
    facilityCode: facilityCode,
  });

  const [updateRequestFormType, setUpdateRequestFormType] = useState({
    facilityID: facilityCode,
    oldRequestFormTypeID: RequestFormType,
    newRequestFormTypeID: requestFormTypePopup?.newRequestFormTypeId,
    requestForumThreadID: formID,
    managementUserID: loggedUser,
    oldRequestFormTitle: oldRequestFormTitle,
    newRequestFormTitle: "",
  });

  const [requestFormTable, setRequestFormTable] = useState({
    formID: formID,
    pageNo: 1,
    rowCountPerPage: 10,
  });

  const [requestFormSubmitted, setRequestFormSubmitted] = useState(false);

  const [pdfdata, setpdfdata] = useState(null);

  const [selectLang, setselectLang] = useState("");
  const [transLoader, setTransLoader] = useState(false);
  const [updateRequestColumn, setUpdateRequestColumn] = useState([]);
  const [updatePostByColumn, setUpdatePostByColumn] = useState([]);
  const prevFacilityCodeRef = useRef(facilityCode);

  const [requestFormData, setRequestFormData] = useState({
    folderPath: "",
    filename: "",
    file: "",
    requestForumThreadID: "",
    facilityID: facilityCode,
    facilityCode: "",
    inmatesId: "",
    managementUserID: loggedUser,
    activeStatus: 0,
    noticesTitle: "",
    pdfAttachPath: "",
    postType: 1,
  });

  //load facility drop down
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    )
      .then((data) => {
        const facilityList = data?.payload;
        const facilityName = facilityList?.find(
          (x) => x?.value === facilityCode
        )?.label;
        setFacilityName(facilityName);
      })
      .catch(() => {
        setFacilityName("");
      });
  }, []);

  useEffect(() => {
    // dispatch(
    //   facilityAction?.GetFacilityDetailsByID({ facilityID: facilityCode })
    // );
    // dispatch(
    //   facilityAction?.GetFacilityStaffReqInfo({
    //     facilityID: facilityCode,
    //   })
    // );
  }, []);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== facilityCode) {
      history.navigate("/Admin/StaffRequestList/PrivateConversation");
    }

    if (prevFacilityCodeRef.current !== facilityCode && facilityCode === 0) {
      history.navigate("StaffRequestList");
    }
  }, [facilityCode]);

  useEffect(() => {
    if (formID == 0) {
      history?.navigate("/Admin/StaffRequestList/PrivateConversation");
    }
  }, [formID])

  useEffect(() => {
    if (formID && InmateID && facilityCode) {
      dispatch(
        staffRequestAction.getRequestFormInfo({
          formID: formID,
          InmateID: InmateID,
          FacilityCode: facilityCode,
        })
      );
    }

    // if (formID) {
    const search = { ...requestFormTable };
    search.formID = formID;
    dispatch(staffRequestAction?.loadInmateRequestForumThreadList(search))
      .then((res) => {
        handleTranslate(selectLang, res?.payload);
        const data = res?.payload?.DataList;
        setRequestFormData({
          ...requestFormData,
          requestForumThreadID: data[0]?.RequestForumThreadID,
          inmatesId: data[0]?.InmateID,
        });
      })
      .catch((err) => {
        showToastNotification("Error while loading data", "error");
      });
    // }
  }, [
    location?.state?.formID,
    requestFormTable?.pageNo,
    requestFormTable?.rowCountPerPage,
    formID,
  ]);

  useEffect(() => {
    switch (updateRequestFormTypePopupdata?.IsSucceed) {
      case 1:
        Popup({
          title: "Message",
          text: `Your chosen form is not allow to create the new request by 
          Inmates but your selected form is allow to create the New request 
          by Inmates. If you want to proceed, Admin  is not allow to create 
          the New request. Are you sure, you want to reassign the selected 
          form to chosen form?`,
          icon: "info",
          confirmButtonText: "YES",
          cancelButtonText: "NO",
          onConfirm: () =>
            dispatch(
              staffRequestAction.updateChangeRequestFormType(
                updateRequestFormType
              )
            ),
        });
        break;
      case 2:
        Popup({
          title: "Message",
          text: `Your chosen form limit is Zero. 
          If you want to proceed, Inmates not allow to create this request form. 
          Admin only allow to create the new request.
          Are you sure, you want to reassign the selected form to chosen form ?`,
          icon: "info",
          confirmButtonText: "YES",
          cancelButtonText: "NO",
          onConfirm: () =>
            dispatch(
              staffRequestAction.updateChangeRequestFormType(
                updateRequestFormType
              )
            ),
        });
        break;
      case 0:
        Popup({
          title: "Message",
          text: `Are you sure you want to Re-assign this Forum to another Forum type?`,
          icon: "info",
          confirmButtonText: "YES",
          cancelButtonText: "NO",
          onConfirm: () =>
            dispatch(
              staffRequestAction.updateChangeRequestFormType(
                updateRequestFormType
              )
            ),
        });
        break;

      default:
        break;
    }
  }, [updateRequestFormTypePopupdata]);

  useEffect(() => {
    if (updateChangeRequestFormTypeData?.IsSucceed > 0) {
      // Insert Management User Activity Log
      dispatch(
        authActions?.ManagementUserActivityLog({
          ManagementUserID: user?.ManagementUserID,
          facilityID: commonFacilityCode ? commonFacilityCode : 0,
          ProcedureName: StoredProcedures?.ChangedFormType,
          UserAction: `UspMoveForumFormToNewForum ( RequestForumThreadID - ${formID} )`,
        })
      );
      showToastNotification("Form Reassigned Successfully.", "success");
      history?.navigate("/Admin/StaffRequestList");
      dispatch(staffRequestAction?.resetForm());
    }
    if (updateChangeRequestFormTypeData?.IsSucceed === -1) {
      showToastNotification("'Forum thread not found.", "success");
      history?.navigate("/Admin/StaffRequestList");
      dispatch(staffRequestAction?.resetForm());
    }
  }, [updateChangeRequestFormTypeData]);

  useEffect(() => {
    dispatch(
      masterActions.GetPublicDefenderNotificationAlert({
        ManagementUserID: loggedUser,
        FacilityID: facilityCode,
      })
    ).then((response) => {
      const updatedMenuList =
        getStoredValue("menu_list") || response?.payload;

      if (updatedMenuList) {
        dispatch(authActions.updateMenuList(updatedMenuList));
      }
    });

    dispatch(
      staffRequestAction?.LoadPrivateConversationRequestUnreadCount({
        ManagementUserID: loggedUser,
        FacilityID: facilityCode,
      })
    );
  }, []);

  useEffect(() => {
    switch (submitRequestFormInfoResponse?.IsSucceed) {
      case 1:
        // Insert Management User Activity Log
        showToastNotification("Form Submitted Successfully.", "success");
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: commonFacilityCode ? commonFacilityCode : 0,
            ProcedureName: StoredProcedures?.RequestPublicDefenderThreadRespond,
            UserAction: `MG User Responded to Inmate Request ( PRequestFormTypeID -${formID})`,
          })
        );
        dispatch(
          staffRequestAction?.UpdateMURequestRead({
            requestID: formID,
            requestFormTypeID: RequestFormType,
            facilityID: facilityCode,
            createdBy: loggedUser,
          })
        );
        dispatch(
          masterActions.GetLoadNotificationAlert({
            ManagementUserID: loggedUser,
            FacilityID: facilityCode,
          })
        );
        dispatch(staffRequestAction?.resetForm());
        dispatch(
          staffRequestAction?.UpdateMURequestRead({
            requestID: formID,
            requestFormTypeID: RequestFormType,
            facilityID: commonFacilityCode,
            createdBy: loggedUser,
          })
        ).then((response) => {
          dispatch(
            masterActions.GetPublicDefenderNotificationAlert({
              ManagementUserID: loggedUser,
              FacilityID: facilityCode,
            })
          ).then((response) => {
            const updatedMenuList =
              getStoredValue("menu_list") ||
              response?.payload;

            if (updatedMenuList) {
              dispatch(authActions.updateMenuList(updatedMenuList));
            }
          });
        });

        setRequestFormData({
          folderPath: "",
          filename: "",
          file: "",
          requestForumThreadID: "",
          facilityID: facilityCode,
          facilityCode: "",
          inmatesId: "",
          managementUserID: loggedUser,
          activeStatus: 0,
          noticesTitle: "",
          pdfAttachPath: "",
          postType: 1,
        });
        // if (formID) {
        const search = { ...requestFormTable };
        search.formID = formID;
        dispatch(staffRequestAction?.loadInmateRequestForumThreadList(search))
          .then((result) => {
            if (result?.payload) {
              handleTranslate(selectLang, result?.payload);
            }
          })
          .catch((err) => {
            showToastNotification("Failed to get grid data", "error");
          });
        setRequestFormSubmitted(true);
        break;
      case -1:
        showToastNotification("Operation Failed", "error");
        break;

      case -2:
        showToastNotification("Thread not exist.", "error");
        break;
      case -3:
        showToastNotification("Text or PDF File is empty", "error");
        break;
      default:
        break;
    }

    // }
    // }
  }, [submitRequestFormInfoResponse, formID]);

  useEffect(() => {
    // if (loggedUser === STAFF_REQUEST_ACCESSIBLE_FA[0]) {
    if (STAFF_REQUEST_ACCESSIBLE_FA.includes(loggedUser)) {
      dispatch(
        staffRequestAction?.LoadFacilityAdminMURequestFormAccess({
          RequestFormType: RequestFormType,
          ManagementUserID: loggedUser,
        })
      );
      // .then((result) => {
      //   const data = result?.payload;

      //   // setIsShowReplayModeModal(
      //   //   Object?.keys(data)?.length > 0 &&
      //   //     data?.FormRespond === 1 &&
      //   //     loadInmateRequestFormList?.DataList?.[0]?.RequestCurrentStatus ===
      //   //       "Open"
      //   // );
      // })
      // .catch((err) => {
      //   showToastNotification("Failed to get data", "error");
      // });
    } else if (UserRoleID !== UserRoleType?.SuperAdmin) {
      //super admin
      // if (RequestFormType) {
      if (RequestFormType > 0) {
        dispatch(
          staffRequestAction?.getRequestFormAccess({
            formID: RequestFormType,
            FacilityCode: facilityCode,
            ManagementUserID: loggedUser,
          })
        );
      }
      // .then((result) => {
      //   const data = result?.payload;
      //   // setIsShowReplayModeModal(
      //   //   Object?.keys(data)?.length > 0 &&
      //   //     data?.FormRespond === 1 &&
      //   //     loadInmateRequestFormList?.DataList?.[0]?.RequestCurrentStatus ===
      //   //       "Open"
      //   // );
      // })
      // .catch((err) => {
      //   showToastNotification("Failed to get data", "error");
      // });
      // }
    } else {
      // setIsShowReplayModeModal(false);
    }
  }, [RequestFormType, indexValue]);

  useEffect(() => {
    if (STAFF_REQUEST_ACCESSIBLE_FA.includes(loggedUser)) {
      setIsShowReplayModeModal(
        Object?.keys(LoadFacilityAdminMURequestFormAccessResponse)?.length >
        0 &&
        LoadFacilityAdminMURequestFormAccessResponse?.FormRespond === 1 &&
        loadInmateRequestFormList?.DataList?.[0]?.RequestCurrentStatus ===
        "Open"
      );
    } else if (UserRoleID !== UserRoleType?.SuperAdmin) {
      setIsShowReplayModeModal(
        Object?.keys(PRFormAccess)?.length > 0 &&
        PRFormAccess?.FormRespond === 1 &&
        loadInmateRequestFormList?.DataList?.[0]?.RequestCurrentStatus ===
        "Open"
      );
    } else {
      setIsShowReplayModeModal(false);
    }
  }, [
    LoadFacilityAdminMURequestFormAccessResponse,
    PRFormAccess,
    loadInmateRequestFormList,
  ]);

  const handlePrints = useReactToPrint({
    pageStyle: `@media print {
      @page {
       size: A4 portrait;
        margin: 2 !important;
         padding: 2 !important;
      }
      body {
        height: auto !important;
        overflow: hidden !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      * {
        
        font-size: 16px !important;
      }

      table, th, td {
        border: 2px solid black !important;
      }

      .print-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        break-inside: avoid;
        page-break-inside: avoid;
      }

      .print-date {
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 14px;
        font-weight: bold;
      }
        
      .rdt_Pagination,
      .sc-diYFot jfOLQZ rdt_Pagination,
      .pagination-postion,
       .sc-diYFot,
       .jfOLQZ
        {
         display: none !important;
       }
    }
  `,

    content: () => {
      const combinedContent = document.createElement("div");
      if (componentRef2.current) {
        combinedContent.appendChild(componentRef2.current.cloneNode(true));
      }
      if (componentRef.current) {
        combinedContent.appendChild(componentRef.current.cloneNode(true));
      }
      if (componentRef1.current) {
        combinedContent.appendChild(componentRef1.current.cloneNode(true));
      }
      return combinedContent;
    },
    onBeforeGetContent: () => { },
  });

  function separatePathAndFileName(filePath) {
    // Find the last index of the '/' character
    const lastSlashIndex = filePath.lastIndexOf('/');

    // Extract folder path and file name

    let folderPath = filePath.substring(0, lastSlashIndex + 1);
    if (process.env.REACT_APP_FOLDER_PATH && process.env.REACT_APP_FOLDER_PATH.trim() !== "") {
      folderPath = `${process.env.REACT_APP_FOLDER_PATH}${filePath.substring(0, lastSlashIndex + 1)}`;
    }

    var filename = filePath.substring(lastSlashIndex + 1);

    return { folderPath, filename };
  }


  const handleDownloadPDF = (e, row) => {
    e?.preventDefault();
    const { folderPath, filename } = separatePathAndFileName(row?.PdfDocAttachPath);
    dispatch(
      staffRequestAction?.DownLoadFile({
        folderPath: folderPath,
        filename: filename,
      })
    )
      .then((result) => {
        setpdfdata(result?.payload);
      })
      .catch((err) => {
        showToastNotification("Failed to view PDF", "error");
      });
    // const splitWord = [...row?.PdfDocAttachPath];
    // const getIndex = splitWord?.lastIndexOf("/");
    // const folderPath = splitWord?.splice(1, getIndex).join("");
    // const fileName = splitWord.splice(1).join("");
    // if (folderPath === "" || fileName === "") return;
    // dispatch(
    //   masterActions?.DownLoadFiles({
    //     filename: fileName,
    //     folderPath: folderPath,
    //   })
    // );
  };

  const exportRequestForm = async () => {
    let generateExcelColumns = ["Request", "Posted By", "Send Date time"];
    const updateTotalRows = {
      ...requestFormTable,
      rowCountPerPage: loadInmateRequestFormList?.TotalRecordCount,
      exportExcel: true,
      pageNo: 1,
    };

    if (formID) {
      const search = { ...requestFormTable };
      search.formID = formID;
      search.rowCountPerPage = loadInmateRequestFormList?.TotalRecordCount;
      search.pageNo = 1;
      search.exportExcel = true;

      const result = await dispatch(
        staffRequestAction?.loadInmateRequestForumThreadList(search)
      );
      const dataList = result?.payload?.DataList;

      const exportData = await Promise.all(
        dataList?.map(async (obj) => {
          const translatedText = (selectLang == "en" || selectLang == "es" ? await translateText(
            obj.ForumPostBody,
            selectLang
          ) : obj.ForumPostBody);
          const translatedBy = (selectLang == "en" || selectLang == "es" ? await translateText(
            obj.ForumThreadPostBy,
            selectLang
          ) : obj.ForumThreadPostBy);
          return {
            Request:
              obj?.IsAttachDocPDF === 1 && obj?.IsPostText === 1
                ? translatedText + " (Replied as PDF)"
                : obj?.IsAttachDocPDF === 1
                  ? "(Replied as PDF)"
                  : translatedText,
            "Posted By": translatedBy,
            "Send Date time": formatDateTimeAMPM(obj.ReqPostSendDate),
          };
        })
      );

      generateXlsx(exportData, generateExcelColumns, "Forum_List");
    }
  };
  const column = useMemo(
    () => [
      {
        name: "Request",
        width: "350px",
        selector: (row) => row.request,
        cell: (row, i) =>
          row.PostByInmate === 1 ? (
            <div div className="d-flex gap-2 ">
              <div className="d-flex  gap-2">
                <i
                  className="fa-solid fa-reply inmate-replied fs-3"
                  aria-hidden="true"
                  title="Inmate Replied"
                ></i>
                <div
                  className="pre-wrap-text"
                  dangerouslySetInnerHTML={{
                    __html:
                      updateRequestColumn?.length > 0
                        ? updateRequestColumn[i]
                        : showmessagecontent(row?.ForumPostBody),
                  }}
                ></div>
              </div>
              {row?.PdfDocAttachPath && (
                <div className="d-flex  align-items-center gap-2">
                  <Link
                    className="btn button-success btn-lg w-inherit cursor-pointer view-pdf-btn"
                    onClick={(e) => handleDownloadPDF(e, row)}
                  >
                    <i class="fa-solid fa-file-pdf me-2"></i>View PDF
                  </Link>
                </div>
              )}
            </div>
          ) : (
            // Example "else if" condition
            <div div className="d-flex flex-wrap gap-2">
              {/* <div className="d-flex flex-wrap gap-2">
                <i
                  className="fa-solid fa-user-shield admin-replied fs-3"
                  aria-hidden="true"
                  title="Admin Replied"
                />
                {row?.ForumPostBody}
              </div> */}
              <div className="d-flex  gap-2">
                <i
                  className="fa-solid fa-user-shield admin-replied fs-3"
                  aria-hidden="true"
                  title="Admin Replied"
                />
                <div
                  className="pre-wrap-text"
                  dangerouslySetInnerHTML={{
                    __html:
                      updateRequestColumn?.length > 0
                        ? updateRequestColumn[i]
                        : showmessagecontent(row?.ForumPostBody),
                  }}
                ></div>
              </div>
              {row?.PdfDocAttachPath && (
                <Link
                  className="btn button-success btn-lg w-inherit cursor-pointer view-pdf-btn"
                  onClick={(e) => handleDownloadPDF(e, row)}
                >
                  <i class="fa-solid fa-file-pdf me-2"></i> View PDF
                </Link>
              )}
            </div>
          ),
        sortable: false,
      },

      {
        name: "Posted By",
        selector: (row) => row.ForumThreadPostBy,
        cell: (row, i) => (
          <div
            className="d-flex flex-wrap gap-2"
            dangerouslySetInnerHTML={{
              __html:
                updatePostByColumn?.length > 0
                  ? updatePostByColumn[i]
                  : showmessagecontent(row?.ForumThreadPostBy),
            }}
          ></div>
        ),
        sortable: false,
      },
      {
        name: "Sent Date Time",
        selector: (row) => formatDateTimeAMPM(row.ReqPostSendDate),
        sortable: false,
      },
    ],
    [
      updateRequestColumn,
      updatePostByColumn,
      loadInmateRequestFormList?.DataList,
    ]
  );

  const handleRowPerPage = (page) => {
    setRequestFormTable((prevState) => ({
      ...prevState,
      rowCountPerPage: page,
      pageNo: 1,
    }));
  };

  const handlePageChange = (page) => {
    setRequestFormTable((prevState) => ({
      ...prevState,
      pageNo: page,
    }));
  };

  const showmessagecontent = (Value) => {
    const highlightedMessageContent = `<span >${Value}</span>`;
    return highlightedMessageContent;
  };

  const handleTranslate = async (
    language,
    data = loadInmateRequestFormList
  ) => {
    setselectLang(language);
    setTransLoader(true);
    const request = data?.DataList?.map((msg) => msg.ForumPostBody);
    const postBy = data?.DataList?.map((msg) => msg.ForumThreadPostBy);
    // const translatedRequest = await translateText(request, language);
    // const translatedPostBy = await translateText(postBy, language);

    const translatedRequest =
      language === "es" || language === "en" ? await translateText(request, language) : request;
    const translatedPostBy =
      language === "es" || language === "en" ? await translateText(postBy, language) : postBy;

    const requestColumn = translatedRequest?.map((text) => {
      return `<span>${text}</span>`;
    });
    const posyByColumn = translatedPostBy?.map((text) => {
      return `<span>${text}</span>`;
    });
    setUpdateRequestColumn(requestColumn);
    setUpdatePostByColumn(posyByColumn);
    setTransLoader(false);
  };

  useEffect(() => {
    handleTranslate(selectLang)
  }, [selectLang])

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e?.target;
    const errorList = { ...errorMessage };
    delete errorList[name];
    setErrorMessage(errorList);
    if (type === "file" && files?.length === 0) {
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "Please upload PDF Document.",
      }));
      const data = { ...requestFormData };
      data["file"] = "";
      data["fileType"] = "";
      data["fileSize"] = 0;
      setRequestFormData(data);
      return;
    }
    if (type === "file" && files?.length > 0) {
      const fileType = files?.[0]?.type;
      const fileSize = files?.[0]?.size;
      if (fileSize > MAX_FILE_SIZE) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: "File size should not exceed 20MB.",
        }));
      }
      if (fileType !== "application/pdf") {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: "Please select PDF Document.",
        }));
        const data = { ...requestFormData };
        data["file"] = "";
        data["fileType"] = fileType;
        data["fileSize"] = 0;
        setRequestFormData(data);
        return;
      }
      // setErrorMessage({});
      const reader = new FileReader();
      reader.onloadend = () => {
        let formData = { ...requestFormData };
        const fileName = files[0]?.name;
        const lastIndex = fileName?.lastIndexOf(".");
        const removedExtensionTxt = [...fileName]
          .splice(0, lastIndex)
          .toString();
        const removeWhitSpace = removedExtensionTxt.replace(
          /[+\-\/,?*:;<>@#$%^&!~\s]/g,
          ""
        );
        const removedExtraTxt = [...removeWhitSpace].splice(0, 100).join(""); //retutn only 100 characters
        const currentDate = getCurrentDate()?.split("/").join("");
        const currentTime = getCurrentTime().split(":").join("");
        const now = new Date();
        // const timestamp = now.getFullYear().toString() +
        //   String(now.getMonth() + 1).padStart(2, "0") +
        //   String(now.getDate()).padStart(2, "0") +
        //   String(now.getHours()).padStart(2, "0") +
        //   String(now.getMinutes()).padStart(2, "0") +
        //   String(now.getSeconds()).padStart(2, "0");
        formData["file"] = reader.result.split(",")[1];
        formData["filename"] = removedExtraTxt;
        formData["fileType"] = files?.[0]?.type;
        formData["fileSize"] = files?.[0]?.size;
        // formData["facilityCode"] = facilityName;
        formData["facilityCode"] =
          GetFacilityStaffReqInfoResponse?.FacilityName;
        setRequestFormData(formData);
      };
      reader.readAsDataURL(files[0]);
    }
    if (type === "radio") {
      const requestData = { ...requestFormData };
      requestData[name] = parseInt(value);
      requestData["noticesTitle"] = "";
      requestData["file"] = "";
      requestData["filename"] = "";
      requestData["fileType"] = "";
      requestData["fileSize"] = 0;
      const fileInput = document.getElementById("fileInput");
      if (fileInput) {
        fileInput.value = "";
      }
      setRequestFormData(requestData);
      setErrorMessage({});
      return;
    }

    if (type === "checkbox") {
      setRequestFormData({ ...requestFormData, [name]: checked ? 1 : 0 });
      return;
    }

    if (type === "textarea") {
      if (/^\s/.test(value)) return;
      setRequestFormData({ ...requestFormData, [name]: value });
      return;
    }
  };

  // const handleValidation = (e, name) => {
  //   const { error } = staffRequestSchema(requestFormData);
  //   const errorList = { ...errorMessage };
  //   if (error?.details) {
  //     const fieldError = error.details.find((e) => e.path.toString() === name);
  //     setErrorMessage((prev) => ({
  //       ...prev,
  //       [name]: fieldError ? fieldError.message : "", // Set the error message if exists, else clear it
  //     }));
  //     const element = document.querySelector(`[name="${name}"]`);
  //     if (element) {
  //       if (fieldError) {
  //         element.classList.add("input-error");
  //       } else {
  //         element.classList.remove("input-error");
  //       }
  //     }
  //   } else {
  //     delete errorList[name];
  //     setErrorMessage(errorList);
  //     const element = document.querySelector(`[name="${name}"]`);
  //     if (element) {
  //       element.classList.remove("input-error");
  //     }
  //     // submitRequestFormInfo();
  //   }
  // };

  const handleValidation = (e, name) => {
    const requestData = { ...requestFormData };
    const file = { type: requestData?.fileType, size: requestData?.fileSize };
    requestData.file = file;
    const { error } = staffRequestSchema(requestData);
    if (error?.details) {
      const fieldError = error.details.find((e) => e.path.toString() === name);
      if (fieldError && Object?.keys(fieldError)?.length > 0) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: fieldError ? fieldError.message : "",
        }));
      }
      return;
    }
    const fieldError = error?.details?.find(
      (e) => e?.path?.toString() === name
    );
    const element = document.querySelector(`[name="${name}"]`);
    if (element) {
      if (fieldError) {
        element.classList.add("input-error");
      } else {
        element.classList.remove("input-error");
      }
    }
  };

  const submitRequestFormInfo = () => {
    const requestData = { ...requestFormData };
    const file = { type: requestData?.fileType, size: requestData?.fileSize };
    requestData.file = file;
    if (requestData?.activeStatus != 1) {
      const { error } = staffRequestSchema(requestData);
      setErrorMessage({});
      if (error?.details) {
        error?.details?.map((e) => {
          const { path } = e;
          setErrorMessage((prev) => ({
            ...prev,
            [path[0]]: e?.message,
          }));
        });
        return;
      }
      if (Object?.keys(errorMessage)?.length > 0) return;
    }
    const search = { ...requestFormData };
    search.requestForumThreadID = formID;
    search.inmatesId = InmateID;
    dispatch(staffRequestAction?.submitRequestFormInfo(search));
    // dispatch(
    //   staffRequestAction?.LoadPrivateConversationRequestUnreadCount({
    //     ManagementUserID: loggedUser,
    //     FacilityID: facilityCode,
    //   })
    // );
  };

  const handleFormReset = () => {
    setErrorMessage({});
    setRequestFormData({
      ...requestFormData,
      noticesTitle: "",
      postType: 1,
      activeStatus: 0,
    });
  };

  if (loading || facilityLoader || transLoader) return <CustomLoader />;

  return (
    <>
      <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
        {pdfdata && (
          <div className="d-flex flex-wrap justify-content-end gap-3">
            {/* <PrintExport
          handlePrintShow={() => {
            handlePrints();
          }}
        /> */}
            <Button
              label="Back"
              type="button"
              icon={"fa-solid fa-angle-left"}
              status="primary"
              onClick={() => {
                setpdfdata(null);
              }}
            />
          </div>
        )}
        {pdfdata ? (
          <PdfViewer data={`data:application/pdf;base64,${pdfdata}`} />
        ) : (
          <div>
            <PrivateConvoRequestFormHeader
              source={sourceFrom}
              requestReview={requestReview}
              list={formDetails}
              handlePrints={handlePrints}
              navigateBack={"/Admin/StaffRequestList/PrivateConversation"}
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
              setRequestFormData={setRequestFormData}
              requestFormSubmitted={requestFormSubmitted}
              setRequestFormSubmitted={setRequestFormSubmitted}
              setUpdateRequestColumn={setUpdateRequestColumn}
            />

            <div className="request-remedy-form">
              <div>
                <article>
                  <div ref={componentRef2}>
                    <div className="d-flex flex-wrap align-items-center profile-row mb-4">
                      <div className="d-flex req-header-img">
                        {GetFacilityStaffReqInfoResponse?.LogoFile && (
                          <img
                            src={
                              "data:image/png;base64," +
                              GetFacilityStaffReqInfoResponse?.LogoFile
                            }
                            alt="facility-logo"
                            className="req-img"
                          />
                        )}
                      </div>
                      <div className="justify-content-center align-items-center req-header-title">
                        <h3 className="text-color py-2 text-center">
                          <span className="label-red req-text">
                            {GetFacilityStaffReqInfoResponse?.FacilityName}
                          </span>
                        </h3>
                      </div>
                    </div>

                    <h4
                      className="request-form-header text-color mt-4"
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fa-solid fa-circle-info me-2"></i> FORUM
                      INFORMATION
                    </h4>
                  </div>

                  <div
                    ref={componentRef}
                    className="m-1 row border-bottom-1 request-form-card details-legal"
                  >
                    <h4
                      className="request-form-header text-color mt-4"
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fa-solid fa-circle-info me-2"></i> REQUEST
                      INFO
                    </h4>
                    {[
                      {
                        label: "Title",
                        value: requestFormInfoResponse?.ForumThreadTitle,
                      },
                      {
                        label: "Inmate Resident ID",
                        value: requestFormInfoResponse?.InmateResidentId,
                      },
                      {
                        label: "Created By",
                        value:
                          requestFormInfoResponse?.IsCreatedByMuUser === 1
                            ? requestFormInfoResponse?.MuUserFullName
                              ? requestFormInfoResponse?.MuUserFullName
                              : "-"
                            : requestFormInfoResponse?.InmateFullName,
                      },
                      {
                        label: "Created On",
                        value: requestFormInfoResponse?.RequestCreateDate,
                      },
                      {
                        label: "POD",
                        value: requestFormInfoResponse?.PodCode
                          ? requestFormInfoResponse?.PodCode
                          : "-",
                      },
                    ].map((item, index) => (
                      <div key={index} className="col-sm-12 col-md-6 col-lg-4">
                        <div className="user-information d-flex flex-wrap align-items-center">
                          <div className="fs-5 p-2  value-info">
                            {item.label}
                          </div>
                          <div className="p-1">:</div>
                          <div className="fs-5 p-2 text-start fw-bold value-text">
                            {item.value || "-"}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div>
                    {isShowReplayModeModal && (
                      <>
                        <div className="details-legal d-flex flex-wrap  border-0">
                          <span className="mb-0 request-form-label">
                            Reply Mode
                          </span>
                          <RadioInput
                            name="postType"
                            id="postType"
                            options={ReplyMode}
                            handleChange={(e) => handleChange(e)}
                            selectedValue={requestFormData?.postType}
                          />
                        </div>
                        <div className="details-legal">
                          {(requestFormData?.postType === 1 ||
                            requestFormData?.postType === 3) && (
                              <TextAreaInput
                                placeholder="Enter Your Description"
                                name="noticesTitle"
                                handleChange={(e) => handleChange(e)}
                                value={requestFormData?.noticesTitle}
                                errorMessage={errorMessage}
                                handleBlur={(e) => {
                                  handleValidation(e, "noticesTitle");
                                }}
                                maxLength={200}
                              />
                            )}
                          {(requestFormData?.postType === 2 ||
                            requestFormData?.postType === 3) && (
                              <FileInput
                                acceptFormat=".pdf"
                                name="file"
                                handleFileChange={(e) => handleChange(e)}
                                errorMessage={errorMessage}
                                id="fileInput"
                              />
                            )}
                        </div>
                        <div className="details-legal border-0">
                          <CheckBoxInput
                            name="activeStatus"
                            label="Close"
                            id={"Close"}
                            handleClick={(e) => handleChange(e)}
                            checked={requestFormData?.activeStatus}
                          />
                        </div>
                        <div className="pb-3 gap-3 d-flex flex-wrap justify-content-start align-items-center">
                          <Button
                            label="Submit"
                            status="success"
                            icon={"fa-solid fa-floppy-disk"}
                            type="button"
                            onClick={() => submitRequestFormInfo()}
                            title={"Submit"}
                            disabled={
                              Object?.keys(
                                LoadFacilityAdminMURequestFormAccessResponse
                              )?.length > 0 &&
                              LoadFacilityAdminMURequestFormAccessResponse?.FormRespond ===
                              0 &&
                              Object?.keys(PRFormAccess)?.length > 0 &&
                              PRFormAccess?.FormRespond === 0
                            }
                          />
                          <Button
                            label="Reset"
                            title="Reset"
                            icon={"fa-solid fa-rotate-right"}
                            status="secondary"
                            type="button"
                            onClick={() => handleFormReset()}
                          />
                        </div>
                      </>
                    )}

                    <div className="m-3  d-flex flex-wrap mobile-left align-items-center gap-3">
                      <Button
                        label="Traducir al español"
                        title="Traducir al español"
                        status="btn-label"
                        type="button"
                        className={"w-max"}
                        icon={"language"}
                        onClick={() => setselectLang("es")}
                      />

                      <Button
                        label="Translate to English"
                        title="Translate to English"
                        status="btn-label"
                        type="button"
                        className={"w-max"}
                        icon={"globe"}
                        onClick={() => setselectLang("en")}
                      />
                      <Button
                        label="Reset"
                        title="Reset"
                        icon={"fa-solid fa-rotate-right"}
                        status="btn-label"
                        type="button"
                        onClick={() => setselectLang("")}
                      />
                      <ExcelExport
                        variant="soft-gray"
                        handleExcelExport={exportRequestForm}
                      />
                    </div>
                    <div ref={componentRef1}>
                      <Table
                        columns={column}
                        data={loadInmateRequestFormList?.DataList}
                        pagination
                        onChangeRowsPerPage={handleRowPerPage}
                        onChangePage={handlePageChange}
                        totalRowCount={
                          loadInmateRequestFormList?.TotalRecordCount
                        }
                        currentPage={requestFormTable?.pageNo}
                        paginationPerPage={requestFormTable.rowCountPerPage}
                      />
                    </div>
                  </div>
                  {/* {formType === 1 ? (
                      
                    ) : (
                      <div className="details-legal">
                        <SelectInput
                          cName={"w-50"}
                          options={formTypeListDropDown}
                          handleChange={(e) => handleFormTypeChange(e)}
                          label="Change To Form Type"
                        />
                        <div className="pt-3 gap-3 d-flex flex-wrap justify-content-start align-items-center">
                          <Button
                            label="Update"
                            title="Update"
                            status="success"
                            icon={"fa-solid fa-pen-to-square"}
                            type="button"
                            onClick={() => handleUpdateFormTypePopup()}
                          />
                          <Button
                            label="Cancel"
                            title="Cancel"
                            status="secondary"
                            type="button"
                            onClick={() => setFormType(1)}
                          />
                        </div>
                      </div>
                    )} */}
                </article>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default React.memo(PrivateConversationRequestForm);
